module.exports = __webpack_public_path__ + "static/img/api3.34829ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/api3.png
// module id = dSNk
// module chunks = 1